import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36cae238"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-info-container" }
const _hoisted_2 = { class: "payment-info-wrapper" }
const _hoisted_3 = { class: "btn-wrapper" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "pay-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1 /* HOISTED */))
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "content-item" }
const _hoisted_9 = { class: "content-item" }
const _hoisted_10 = { class: "book-info-wrapper" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "book-info-title" }, "예약번호", -1 /* HOISTED */))
const _hoisted_12 = { class: "book-ids-wrapper" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "book-id" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal-backdrop",
      onClick: $setup.emitOnClickClose
    }),
    _createVNode(_Transition, {
      appear: "",
      name: "slide-up"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", { onClick: $setup.emitOnClickClose }, [
              _createVNode($setup["InlineSvg"], {
                src: require('@/assets/icons/x-icon.svg'),
                alt: "닫기"
              }, null, 8 /* PROPS */, ["src"])
            ])
          ]),
          _createElementVNode("section", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString($props.paymentDetailInfo.type === $setup.IPaymentInfoType.PAID
                ? "결제완료"
                : "결제취소"), 1 /* TEXT */),
            _createElementVNode("p", {
              class: _normalizeClass(["pay-amount", {
              canceled: $props.paymentDetailInfo.type === $setup.IPaymentInfoType.CANCELED,
            }])
            }, [
              _createElementVNode("strong", null, _toDisplayString($setup.getFormattedAmount()), 1 /* TEXT */)
            ], 2 /* CLASS */)
          ]),
          _hoisted_6,
          _createElementVNode("section", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString($props.paymentDetailInfo.type === $setup.IPaymentInfoType.PAID
                ? "결제일시"
                : "취소일시"), 1 /* TEXT */),
              _createElementVNode("span", null, _toDisplayString($props.paymentDetailInfo.updatedAt), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString($props.paymentDetailInfo.type === $setup.IPaymentInfoType.PAID
                ? "결제금액"
                : "취소금액"), 1 /* TEXT */),
              _createElementVNode("span", null, _toDisplayString($setup.useCurrencyFormat($props.paymentDetailInfo.amount)) + "원", 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("section", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.paymentDetailInfo.bookInfos, (bookInfo, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["book-id-wrapper", {
                'first-column': index % 3 === 0,
                'second-column': index % 3 === 1,
                'third-column': index % 3 === 2,
              }]),
                  key: index,
                  onClick: ($event: any) => (
                _ctx.$emit(
                  'onClickBookDetailId',
                  bookInfo.bookId,
                  bookInfo.bookDetailId
                )
              )
                }, [
                  _createElementVNode("a", _hoisted_14, _toDisplayString($setup.shortenBookDetailUid(bookInfo.bookDetailId)), 1 /* TEXT */)
                ], 10 /* CLASS, PROPS */, _hoisted_13))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}